import { result } from 'lodash-es';
import { Subject, Observable } from 'rxjs';

/* eslint-disable */
/* eslint-disable @typescript-eslint/naming-convention, no-underscore-dangle, id-blacklist, id-match */

export class LoginResponse {
  public token: string;
  public user: any;
  public permissions: string[];
}

export class LoginForm {
  public username: string;
  public password: string;
}

export class QuotaData {
  public id?: number;
  public branch?: string[];
  public paket?: string[];
  public periode?: string[];
  public name: string;
  public male_quota: number;
  public female_quota: number;
  public created_at?: string;
  public updated_at?: string;
  public action?: string;
  public status: number;
}

export class ListQuotaDataResponse {
  public result: QuotaData[] = [];
  public page: number;
  public morePage: boolean;
}

export class ListQuotaDataResponseFilter {
  public branch?: string[];
  public paket?: string[];
  public name?: string;
  public cabang?: string;
  public status? = '';
  public page? = 1;
  public per_page? = 10;
}

export class dataStatus {
  public id?: number;
  public name: string;
  public desc: string;
  public created_at?: string;
  public updated_at?: string;
}

export class ListStatusResponse {
  public result: dataStatus[];
  public id?: number;
  public name: string;
  public desc: string;
  public created_at?: string;
  public updated_at?: string;
}

export class dataGrade {
  public id?: number;
  public branch_id?: number;
  public branch?: string[];
  public periode?: PeriodeData[];
  public course_package?: CourseData[];
  public course?: CourseData[];
  public periode_id?: string[];
  public course_id?: string[];
  public name: string;
  public form_name: string;
  public price: number;
  public desc: number;
  public status: number;
  public order: number;
  public created_at?: string;
  public updated_at?: string;
  public deleted_at?: string;
}

export class ListGradeResponse {
  public data: dataGrade[];
  public page: number;
  public morePage: boolean;
  public next_page_url: string;
  public prev_page_url: string;
}

export class ListGradeFilter {
  public page? = 1;
  public per_page? = 10;
  public branch?: string;
  public name?: string;
  public form_name?: string;
  public price?: number;
  public status?: number;
  public periode?: string[];
  public course_package?: string[];
}

export class MeetHours {
  public id?: number;
  public hour: string;
  public status: number;
  public created_at?: string;
  public updated_at?: string;
}

export class ListMeetHoursResponse {
  public data: MeetHours[];
  public page: number;
  public morePage: boolean;
  public next_page_url: string;
  public prev_page_url: string;
}

export class ListMeetHoursFilter {
  public page? = 1;
  public per_page? = 10;
  public hour?: string;
  public status?: number;
}

export class dataCourseCategory {
  public id?: number;
  public name: string;
  public status: number;
  public created_at?: string;
  public updated_at?: string;
  public deleted_at?: string;
}

export class ListCourseCategoryResponse {
  public data: dataCourseCategory[];
  public page: number;
  public morePage: boolean;
  public next_page_url: string;
  public prev_page_url: string;
}

export class ListCourseCategoryFilter {
  public page? = 1;
  public per_page? = 10;
  public name?: string;
  public status?: number;
}

export class PeriodeData {
  public id?: number;
  public date: number;
  public month: number;
  public year?: number;
  public grade?: dataGrade[];
  public status? = 'ACT';
  public position?: number;
  public periode?: any;
  public updated_by?: string;
  public created_at?: string;
  public updated_at?: string;
  public cabang?: string[];
  public jenjang?: string[];
}

export class ListPeriodeResponse {
  public result: PeriodeData[] = [];
  public page: number;
  public morePage: boolean;
}

/**
 * Payload "Tambah Data Registrasi" — bentuknya mengikuti persis apa yang
 * divalidasi RegistrationController::registrationRules() di BE. Dikirim
 * terbungkus sebagai { data: <payload ini> }.
 */
export class AddNewRegistrationPayload {
  public branch: string;
  public name: string;
  public gender: string;
  public education: string;
  public email: string;
  public phone: string;
  public periode_date: number;
  public periode_month: number;
  public periode_year: number;
  public course: string;
  /** Wajib dari panel — BE meng-override aturannya di storeFromPanel. */
  public cs: string;
  public cs_id?: string;
  public lead_id?: string | number;
  public grade?: string;
  public meet_hour?: string;
  public pickup?: string;
  public pickupLocation?: string;
  public passenger?: number;
  public voucher?: string;
  public utm_source?: string;
  public utm_medium?: string;
  public utm_campaign?: string;
  public utm_content?: string;
}

export class GenerateRegistrationLinkPayload {
  public branch: string;
  public periode_date: number;
  public periode_month: number;
  public periode_year: number;
  public course: string;
  public cs: string;
  public cs_id?: string;
  public lead_id?: number | null;
  public grade?: string | null;
  public meet_hour?: string | null;
  public pickup?: string | null;
  public pickupLocation?: string | null;
  public passenger?: number | null;
  public voucher?: string | null;
  public voucher_discount?: number;
  public admin_fee?: number;
  public total_cost?: number;
  public payment_method?: string | null;
  public utm_source?: string | null;
  public utm_medium?: string | null;
  public utm_campaign?: string | null;
  public utm_content?: string | null;
}

export class GenerateRegistrationLinkResponse {
  public success: boolean;
  public message: string;
  public data: {
    id: number;
    token: string;
    url: string;
    expires_at: string;
    status: string;
  };
}

export class ListPeriodeFilter {
  public date?: number;
  public month?: number;
  public year?: number;
  public status? = '';
  /** Batas bawah/atas tanggal periode, format Y-m-d. */
  public periode_from?: string;
  public periode_to?: string;
  public page? = 1;
  public per_page? = 10;
  public cabang?: any[];
  public jenjang?: string[];
}

export class RegistrationData {
  public id?: number;
  public course_cost: number;
  public course_duration: number;
  public course_name: string;
  public course: string;
  public down_payment: number;
  public down_payment_due_date: string;
  public camp?: string;
  public email: string;
  public name: string;
  public gender: string;
  public origin: string;
  public periode_date: number;
  public periode_month: number;
  public periode_year: number;
  public education: string;
  public tshirt: string;
  public phone: string;
  public regcode: string;
  public branch: string;
  public status: string;
  public lead?: string;
  public aff?: string;
  public utm_source?: string;
  public cs?: string;
  public is_retention?: number;
  public city_id?: number;
  public courseStartDate?: string;
  public courseEndDate?: string;
  public pickup?: string;
  public pickupLocation: string;
  public pickupTime: string;
  public passenger?: number;
  public pickup_cost?: number;
  public admin_fee?: number;
  public ac_room?: number;
  public ac_room_cost?: number;
  public final_payment: number;
  public full_payment: number;
  public payment?: PaymentData[];
  public student_history_journey?: StudentHistoryJourney[];
  public total_student_payment?: number;
  public grade?: string;
  public grade_cost?: number;
  public student_additional_info?: AdditionalInfo[];
  public labels?: LabelDataModel[];
  public checkin_time: string;
  public idCardPic?: string;
  public studentPic?: string;
  public created_at?: string;
  public updated_at?: string;
  public updated_by?: string;
  public voucher?: string;
  public discount_total?: any;
  public discount_nominal?: any;
  public meet_hour_id?: string;
  public is_toolkit_received?: boolean;
  public toolkit_received_at?: string;
  public toolkit_received_by?: string;
  public returning_student_check?: ReturningStudentCheck | null;
}

/**
 * Hasil deteksi siswa lama (alumni): jumlah registrasi sebelumnya milik
 * orang yang sama yang sudah GRADUATED. null = belum pernah dicek.
 */
export interface ReturningStudentCheck {
  graduated_count: number;
  updated_at?: string;
}

export type CourseHistoryMatch = 'phone' | 'email' | 'idcard';

export interface CourseHistoryItem {
  id: number;
  regcode: string;
  nis: string | null;
  name: string;
  phone: string;
  email: string;
  branch: string;
  course: string;
  course_name: string;
  course_duration: number;
  course_category: string | null;
  grade_name: string | null;
  main_class_name: string | null;
  periode_date: number;
  periode_month: number;
  periode_year: number;
  courseStartDate: string | null;
  courseEndDate: string | null;
  checkin_time: string | null;
  status: 'GRADUATED' | 'DROPOUT' | 'CUTOFF' | 'CUTOFF_TO_ONLINE';
  is_retention: number;
  pt_grammar: number | null;
  pt_speaking: number | null;
  placement_test: number | string | null;
  matched_by: CourseHistoryMatch[];
}

export interface CourseHistoryResponse {
  regcode: string;
  name: string;
  graduated_count: number;
  histories: CourseHistoryItem[];
}

export interface StudentHistoryJourney {
  id: number;
  name: string;
  description: string;
  data: HistoryJourneyData;
  user_id: number;
  student_id: number;
  created_at: string;
  updated_at: string;
}

export interface HistoryJourneyData {
  id?: number;
  bank?: string;
  date?: string;
  type?: string;
  method?: string;
  channel?: string;
  edcCost?: string;
  nominal?: string;
  regcode?: string;
  created_at?: string;
  updated_at?: string;
  updated_by?: string;
  description?: string;
  id_idn_payment?: number | null;
  id_auto_payment?: number | null;
  id_briva_payment?: number | null;
  id_manual_payment?: number | null;
  tshirt?: string;
  is_toolkit_received?: boolean;
  toolkit_status?: string;
  petugas?: string;
  [key: string]: any;
}

export class ListRegistrationResponse {
  public paid: number;
  public paid_omset: number;
  public registered: number;
  public registered_omset: number;
  public result: RegistrationData[];
  public page: number;
  public morePage: boolean;
}

export class ListRegistrationFilter {
  public branch? = '';
  public regcode?: string;
  public is_ac?: string;
  public name?: string;
  public gender? = '';
  public email?: string;
  public tshirt?: string;
  public education?: string;
  public phone?: string;
  public course?: string;
  public is_partial?: boolean;
  public periode?: PeriodeData;
  public down_payment?: number;
  public status? = '';
  public lead? = null;
  public aff? = null;
  public utm_source? = null;
  public cs? = null;
  public extends_program?: number;
  public pickup? = '';
  public pickupLocation? = '';
  public pickupTime?: string;
  public passenger? = 0;
  public startDate?: string;
  public endDate?: string;
  public checkinDate?: string;
  public orderBy?: string;
  public voucher?: string;
  public page? = 1;
  public per_page? = 10;
  public download? = false;
  public grade?: string;
  public meet_hour_id?: string;
  public label_id?: string;
  public is_returning? = '';
}

export class ListRegistrationFilterAct {
  public branch? = false;
  public regcode? = true;
  public name? = true;
  public gender? = false;
  public email? = false;
  public course? = true;
  public is_partial? = true;
  public periode? = true;
  public down_payment? = false;
  public status? = true;
  public lead? = false;
  public aff? = false;
  public utm_source? = false;
  public cs? = false;
  public extends_program? = false;
  public pickup? = false;
  public pickupLocation? = false;
  public pickupTime? = false;
  public passenger? = false;
  public startDate? = false;
  public endDate? = false;
  public tshirt? = false;
  public education? = false;
  public is_ac? = false;
  public phone? = false;
  public voucher? = false;
  public grade? = false;
  public meet_hour_id? = false;
  public is_checked? = false;
  public label? = true;
  public is_returning? = false;
}

export class AdditionalInfo {
  public grade_id?: number;
  public meet_hour_id?: number;
  public course_package_id?: number;
  public va_number?: string;
  public payment_method: string;
  public bank_code: string;
  public grade: dataGrade[];
  public meet_hours?: MeetHours[];
  public course_package?: CourseData[];
  public is_checked?: boolean;
  public is_toolkit_received?: boolean;
  public toolkit_received_at?: string;
  public toolkit_received_by?: string;
}

export class CourseData {
  public id?: number;
  public code: string;
  public name?: string;
  public branch?: string;
  public photo?: string;
  public short_description?: string;
  public description?: string;
  public cost_promotion?: number;
  public cost_bpp?: number;
  public cost?: number;
  public active_date?: string[];
  public grade?: dataGrade[];
  public active_month?: string[];
  public active_year?: string;
  public active_periode?: string[];
  public jenjang?: string[];
  public duration: number;
  public position?: number;
  public quota_id?: number;
  public quota?: any;
  public type?: string;
  public extra?: string;
  public termpayment: boolean;
  public secondterm: number;
  public finalterm: number;
  public is_partial: boolean;
  public is_photo_identity: number;
  public is_additional_meet_hour: number;
  public meet_hours?: MeetHours[];
  public is_camp: boolean;
  public is_ac: boolean;
  public start_active: string;
  public stop_active: string;
  public nis_code?: string;
  public status?: string;
  public updated_by?: string;
  public created_at?: string;
  public updated_at?: string;
  public category?: number;
  public is_renewal?: boolean;
}

export class ListCourseResponse {
  public result: CourseData[] = [];
  public page: number;
  public morePage: boolean;
}

export class CourseFilter {
  public code?: string;
  public name?: string;
  public branch?: any;
  public periode?: number[];
  public education?: string[];
  public active_date?: string;
  public active_month?: string;
  public active_year?: string;
  public hasActiveStudent?: boolean;
  public studentPeriode?: string;
  public status? = '';
  public page? = 1;
  public per_page? = 10;
  public is_camp? = 10;
}

export class TemplateData {
  public id?: number;
  public media: string;
  public type: string;
  public subject: string;
  public message: string;
  public channel: string;
  public template_name: string;
  public language: string;
  public updated_by?: string;
  public created_at?: string;
  public updated_at?: string;
}

export class ListTemplateResponse {
  public result: TemplateData[] = [];
  public current_page?: number;
  public per_page?: number;
  public prev_page_url?: string;
  public next_page_url?: string;
  public total?: number;
  public last_page?: number;
}

export class ListTemplateFilter {
  public media?: string;
  public type?: string;
  public channel?: string;
  public template_name?: string;
  public page?: number;
  public per_page?: number;
}

export class UserPermission {
  public id: number;
  public name: string;
}

export class UserData {
  public id?: number;
  public username: string;
  public branch?: string[];
  public dataStatus?: string[];
  public dataAccessDownload?: string[];
  public name: string;
  public password?: string;
  public confirm_password?: string;
  public access: string;
  public scope: string;
  public permissions?: UserPermission[];
  public updated_by?: string;
  public created_at?: string;
  public updated_at?: string;
}

export class ListUserResponse {
  public data: UserData[] = [];
  public current_page: number;
  public per_page: number;
  public prev_page_url: string;
  public next_page_url: string;
}

export class ListUserFilter {
  public username?: string;
  public name?: string;
  public access? = '';
  public page? = 1;
  public per_page? = 10;
}

export class TemplateDialogInput {
  public type: string;
  public data: TemplateData;
}

export class DeleteDialogInput {
  public item: string;
  public endpoint: string;
  public id: number | string;
  public data: {
    key: string;
    value: any;
  }[];
}

export class ConfirmDialogInput {
  public titleDialog: string;
  public descDialog?: string;
  public onSubmit: ()=> void;
}

export class StudentData {
  public id?: number;
  public regcode: string;
  public branch: string;
  public nis?: string;
  public name: string;
  public gender = '';
  public birthplace: string;
  public birthplace_id: number;
  public birthplace_type: string;
  public birthdate: string;
  public email: string;
  public phone: string;
  public address: string;
  public subdistrict: string;
  public subdistrict_id: number;
  public city: string;
  public city_type: string;
  public city_id: number;
  public checkin_time: string;
  public province: string;
  public province_id: number;
  public education: string;
  public tshirt: string;
  public payment?: PaymentData[];
  public parent_phone: string;
  public periode_date: number;
  public periode_month: number;
  public periode_year: number;
  public periode: string;
  public course: string;
  public course_name: string;
  public course_duration: number;
  public course_cost: number;
  public course_bpp: number;
  public course_data?: CourseData;
  public courseEndDate: string;
  public courseStartDate: string;
  public down_payment: number;
  public full_payment: number;
  public camp?: string;
  public pt_grammar?: number;
  public pt_speaking?: number;
  public placement_test?: number;
  public main_class?: number;
  public main_class_name?: string;
  public camp_class?: number;
  public camp_class_name?: string;
  public down_payment_due_date: string;
  public status: string;
  public lead?: string;
  public aff?: string;
  public utm_source?: string;
  public cs?: string;
  public pickup?: string;
  public pickupLocation: string;
  public pickupTime: string;
  public passenger?: number;
  public pickup_cost?: number;
  public tagname?: string;
  public idCardPic?: string;
  public studentPic?: string;
  public voucher?: string;
  public idcard?: string;
  public final_payment: number;
  public is_retention?: number;
  public origin: string;
  public created_at?: string;
  public updated_at?: string;
  public updated_by?: string;
  public pivot?: CampStudentPivotData;
  public camphistory?: CampData[];
  public academic?: AcademicResult[];
  public certificates?: CertificateData[];
  public academicSum?: AcademicSum[];
  public student_additional_info?: AdditionalInfo[];
  public labels?: LabelDataModel[];
  public resultSum?: number;
  public tos: number;
  public is_toolkit_received?: boolean;
  public toolkit_received_at?: string;
  public toolkit_received_by?: string;
}

export interface ToolkitResponse {
  status: 'success' | 'already_received' | 'error';
  message: string;
  data?: any;
}

export interface SelfCheckinLinkResponse {
  regcode: string;
  name: string;
  status: string;
  url: string;
  token: string;
  expires_at: string;
}

export class ListStudentResponse {
  public checkin: number;
  public checkin_omset: number;
  public graduated: number;
  public graduated_omset: number;
  public result: StudentData[];
  public page: number;
  public morePage: boolean;
}

export class ListStudentRombonganResponse {
  public result: StudentData[];
  public page: number;
  public morePage: boolean;
}

export class ListStudentFilter {
  public regcode?: string;
  public list_regcode?: string[];
  public branch? = '';
  public nis?: string;
  public name?: string;
  public gender = '';
  public birthplace_id?: number;
  public birthdate?: string;
  public email?: string;
  public phone?: string;
  public subdistrict_id?: number;
  public city_id?: number;
  public province_id?: number;
  public education? = '';
  public tshirt? = '';
  public is_checked? = 'all' as string | boolean;
  public course?: string;
  public courses?: string[];
  public is_partial?: boolean;
  public periode?: PeriodeData;
  public camp?: string;
  public camps?: string[];
  public main_class?: number;
  public camp_class?: number;
  public has_mainclass?: number;
  public has_campclass?: number;
  public need_class?: number;
  public down_payment?: number;
  public status? = '';
  public lead? = null;
  public aff? = null;
  public utm_source? = null;
  public cs? = null;
  public extendsProgram?: string;
  public pickup? = '';
  public pickupLocation? = '';
  public passenger?: string | number;
  public pickupTime?: string;
  public startDate?: string;
  public endDate?: string;
  public checkinStartDate?: string;
  public checkinEndDate?: string;
  public checkinDate?: string;
  public placement_test?: number;
  public min_pt?: number;
  public max_pt?: number;
  public with_academic?: boolean;
  public academic_month?: number;
  public with_certificate?: boolean;
  public order?: string;
  public order_by: string;
  public voucher: string;
  public page? = 1;
  public per_page? = 10;
  public download? = false;
  public grade?: string[];
  public meet_hour_id?: string[];
  public label_id?: string;
}

export class ListStudentFilterAct {
  public regcode? = false;
  public branch? = false;
  public nis? = false;
  public name? = false;
  public gender? = false;
  public birthplace? = false;
  public birthdate? = false;
  public email? = false;
  public phone? = false;
  public address? = false;
  public subdistrict? = false;
  public city? = false;
  public province? = false;
  public education? = false;
  public tshirt? = false;
  public course? = false;
  public is_partial? = false;
  public periode? = false;
  public camp? = false;
  public main_class? = false;
  public camp_class? = false;
  public status? = true;
  public lead? = false;
  public aff? = false;
  public utm_source? = false;
  public cs? = false;
  public extendsProgram? = false;
  public startDate? = false;
  public endDate? = false;
  public checkinStartDate? = false;
  public checkinEndDate? = false;
  public checkinDate? = false;
  public voucher? = false;
  public pickup? = false;
  public pickupLocation? = false;
  public passenger? = false;
  public pickupTime? = false;
  public grade? = true;
  public is_checked? = false;
  public meet_hour_id? = true;
  public label? = true;
}

export class StudentResumeFilter {
  public branch? = '';
  public periode?: string;
  /** '' = semua, '1' = ya, '0' = tidak. */
  public is_rombongan?: '' | '0' | '1' = '';
  public is_retention?: '' | '0' | '1' = '';
}

export class ManualPaymentData {
  public id?: number;
  public date: string;
  public regcode: string;
  public email: string;
  public nominal: number;
  public bank: string;
  public attachment?: string;
  public status: string;
  public updated_by: string;
  public updated_at: string;
  public created_at: string;
}

export class ManualPaymentResponse {
  public result: ManualPaymentData[];
  public page: number;
  public morePage: boolean;
}

export class ManualPaymentFilter {
  public id?: number;
  public regcode?: string;
  public email?: string;
  public bank? = '';
  public nominal?: number;
  public startDate?: string;
  public endDate?: string;
  public status? = '';
  public page? = 1;
  public per_page? = 10;
}

export class AutoPaymentData {
  public id?: number;
  public date: string;
  public regcode?: string;
  public nominal: number;
  public bank: string;
  public status: string;
  public updated_by: string;
  public updated_at: string;
  public created_at: string;
}

export class AutoPaymentResponse {
  public result: AutoPaymentData[];
  public page: number;
  public morePage: boolean;
}

export class AutoPaymentFilter {
  public id?: number;
  public regcode?: string;
  public bank? = '';
  public nominal?: number;
  public startDate?: string;
  public endDate?: string;
  public status? = '';
  public page? = 1;
  public per_page? = 10;
}

export class AutoPaymentUpdate {
  public id: number;
  public status: string;
  public oldRegCode?: string;
  public newRegCode: string;
}

export class IDNPaymentData {
  public id?: number;
  public date: string;
  public regcode: string;
  public ref_number: string;
  public bill_component_id: string;
  public merchant_ref_number: string;
  public nominal: number;
  public description: string;
  public updated_by: string;
  public updated_at: string;
  public created_at: string;
}

export class IDNPaymentResponse {
  public result: IDNPaymentData[];
  public page: number;
  public morePage: boolean;
}

export class IDNPaymentFilter {
  public id?: number;
  public regcode?: string;
  public ref_number?: string;
  public bill_component_id?: string;
  public merchant_ref_number?: string;
  public nominal?: number;
  public startDate?: string;
  public endDate?: string;
  public page? = 1;
  public per_page? = 10;
}

export class ProvinceData {
  public province: string;
  public province_id: number;
}

export class ListProvinceResponse {
  public data: ProvinceData[];
}

export class CityData {
  public city_id: number;
  public city_name: string;
  public province_id: number;
  public province: string;
  public type: string;
}

export class ListCityResponse {
  public data: CityData[];
}

export class ListCityFilter {
  public city_name?: string;
}

export class PaymentData {
  public id: number;
  public date: string;
  public created_at: string;
  public instalmentDueDate: string;
  public description: string;
  public id_auto_payment?: number;
  public id_manual_payment?: number;
  public regcode: string;
  public method: string;
  public aff: string;
  public type: string;
  public instalmentType: string;
  public channel: string;
  public bank: string;
  public edcCost?: number;
  public nominal: number;
  public instalmentNominal: number;
  public updated_by: string;
  public student?: StudentData;
  public courseData?: CourseData;
  public pickup?: any;
  public pickupLocation?: any;
  public passenger?: number;
  public grade?: number;
}

export class ListPaymentResponse {
  public result: PaymentData[];
  public page: number;
  public morePage: boolean;
}

export class ListPaymentFilter {
  public regcode?: string;
  public type?: string;
}

export class SelectCityFilter {
  public city: Observable<CityData[]>;
  public input = new Subject<string>();
  public isLoading = false;
}

export class BrivaPaymentData {
  public id?: number;
  public date: string;
  public regcode: string;
  public tellerid: string;
  public paymentDate: string;
  public nominal: number;
  public description: string;
  public updated_by: string;
  public updated_at: string;
  public created_at: string;
}

export class BrivaPaymentResponse {
  public result: BrivaPaymentData[];
  public page: number;
  public morePage: boolean;
}

export class BrivaPaymentFilter {
  public id?: number;
  public regcode?: string;
  public nominal?: number;
  public startDate?: string;
  public endDate?: string;
  public page? = 1;
  public per_page? = 10;
}

export class RegReportFilter {
  public scale?: string;
  public status?: string;
  public group?: string;
  public startDate?: string;
  public endDate?: string;
}

export class RegistrationReportData {
  public waktu: string;
  public total: number;
}

export class GraphData {
  public name: string;
  public value: number;
}

export class ListLeadsFilter {
  public name?: string;
  public phone?: string;
  public status? = '';
  public startDate?: string;
  public endDate?: string;
  public page? = 1;
  public per_page? = 10;
}

export class LeadsData {
  public id: number;
  public name: string;
  public phone: string;
  public utm_source: string;
  public status: string;
  public updated_by: string;
  public created_at: string;
  public updated_at: string;
  public cs: string;
  public utm_campaign: string;
  public utm_medium: string;
  public utm_content: string;
  public utm_term: string;
}

export class ListLeadsResponse {
  public result: LeadsData[];
  public page: number;
  public morePage: boolean;
}

export class PickupData {
  public id: number;
  public pickup_name: string;
  public location: string;
  public pickup: string;
  public location_name: string;
  public passenger: number;
  public cost: number;
  public status: number;
}

/** Opsi dropdown penjemputan — hasil query distinct dari pickup_costs. */
export class PickupVehicleData {
  public pickup: string;
  public pickup_name: string;
  /** 1 = aktif, 0 = nonaktif (hanya ada di response clientapi/pickup/lookup). */
  public status?: number;
}

export class PickupLocationData {
  public location: string;
  public location_name: string;
  /** 1 = aktif, 0 = nonaktif (hanya ada di response clientapi/pickup/lookup). */
  public status?: number;
}

/** Response clientapi/pickup/lookup: semua kode (termasuk nonaktif) + jumlah penumpang distinct. */
export class PickupLookupData {
  public vehicles: PickupVehicleData[] = [];
  public locations: PickupLocationData[] = [];
  public passengers: number[] = [];
}

export class PickupPassengerData {
  public passenger: number;
  public cost: number;
}

export class ListPickupDataResponse {
  public current_page: number;
  public data: PickupData[] = [];
  public first_page_url: string;
  public from: number;
  public next_page_url: string;
  public per_page: number;
  public prev_page_url: string;
  public to: number;
}

export class FilterPickupData {
  public pickup?: string;
  public pickup_name?: string;
  public location?: string;
  public location_name?: string;
  public passenger?: number;
  public cost?: number;
  public page? = 1;
  public per_page? = 10;
  public status?: number;
}

/**
 * Satu siswa pada halaman operasional penjemputan (role penjemputan).
 * Bentuknya mengikuti response clientapi/pickup-task/list.
 */
export interface PickupTaskItem {
  id: number;
  regcode: string;
  name: string;
  gender: string;
  phone: string;
  parent_phone: string;
  pickup: string;
  status: string;
  pickupLocation: string;
  pickupLocationName: string;
  passenger: number;
  pickupTime: string;
  cs: string;
  pickup_cost: string;
  periode_date: number;
  periode_month: number;
  periode_year: number;
  pickup_note: string | null;
  pickup_contacted: boolean | number | null;
}

/** Satu grup periode berisi daftar siswa yang perlu dijemput. */
export interface PickupTaskPeriode {
  periode: string;
  total: number;
  registrations: PickupTaskItem[];
}

export interface PickupTaskListResponse {
  data: PickupTaskPeriode[];
}

/** Payload simpan keterangan + penanda sudah dihubungi. */
export interface PickupTaskStatusPayload {
  student_id: number;
  pickup_note: string | null;
  pickup_contacted: boolean;
}

export class AdminFeeData {
  public id: number;
  public name: string;
  public nominal: number;
  public category: string;
  public is_active: number;
  public updated_at: string;
  public created_at: string;
}

export class OnSelectedDataPaymentForDelete {
    public regcode: string | null | undefined;
    public payment_id: number | null | undefined;
    public student_id: number | null | undefined;
}

export class ListAdminFeeDataResponse {
  public current_page: number;
  public data: AdminFeeData[] = [];
  public first_page_url: string;
  public from: number;
  public next_page_url: string;
  public per_page: number;
  public prev_page_url: string;
  public to: number;
}

export class FilterAdminFeeData {
  public name?: string;
  public nominal?: string;
  public category?: string;
  public is_active?: number;
  public page? = 1;
  public per_page? = 10;
}

export class ListCheckinResponse {
  public current_page: number;
  public data: RegistrationData[];
  public first_page_url?: string;
  public from: number;
  public next_page_url?: string;
  public per_page: number;
  public prev_page_url?: string;
  public to: number;
}

export class UpdateCampData {
  public regcode: string;
  public camp: string;
}

export class ListAllPaymentResponse {
  public current_page: number;
  public data: PaymentData[];
  public first_page_url?: string;
  public from: number;
  public next_page_url?: string;
  public per_page: number;
  public prev_page_url?: string;
  public to: number;
}

export class PaymentSummary {
  public total = 0;
  public total_nominal = 0;
}

export class AllPaymentFilter {
  public regcode?: string;
  public name? = '';
  public phone?: string;
  public periode?: string;
  public branch?: string;
  public affiliate?: string;
  public bank? = '';
  public nominal?: number;
  public startDate?: string;
  public endDate?: string;
  public channel? = '';
  public type? = '';
  public method? = '';
  public student_status? = '';
  public periode_year?: number;
  public periode_start_month?: number;
  public periode_end_month?: number;
  public periode_start?: string;
  public periode_end?: string;
  public page? = 1;
  public per_page? = 10;
  public order?: string;
  public with_student = null;
  public download = false;
}

/**
 * Penanda filter mana yang sedang aktif (chip menyala). Field filter hanya
 * ditampilkan dan hanya ikut dikirim ke backend jika flag-nya true — sama seperti
 * konsep filterAct pada halaman Daftar Registrasi.
 */
export class AllPaymentFilterAct {
  public startDate = true;
  public endDate = true;
  public branch = true;
  public periode = false;
  public type = false;
  public regcode = false;
  public name = false;
  public phone = false;
  public channel = false;
  public method = false;
  public bank = false;
  public nominal = false;
  public affiliate = false;
  public student_status = false;
  public periode_year = false;
  public periode_month = false;
  public periode_range = false;
}

export class PaymentReportData {
  public bank: string;
  public course: string;
  public created_at: string;
  public date: string;
  public description: string;
  public edcCost: number;
  public method: string;
  public name: string;
  public nominal: number;
  public periode_date: number;
  public periode_month: number;
  public periode_year: number;
  public pickup_cost: number;
  public regcode: string;
  public type: string;
  public updated_at: string;
  public updated_by: string;
}

export class Crud {
  public create = false;
  public read = false;
  public update = false;
  public delete = false;
  public download = false;
  public use = false;
}
export class PermissionData {
  public checkup_accounting: Pick<Crud,'update'> = new Crud();
  public student_process_checkin: Pick<Crud,'update'> = new Crud();
  public student_toolkit: Pick<Crud,'update'> = new Crud();
  public delete_payment_active_student: Pick<Crud,'delete'> = new Crud();
  public delete_payment_instalment: Pick<Crud,'delete'> = new Crud();
  public receipt: Pick<Crud, 'download'> = new Crud();
  public student_modify_cs_name: Pick<Crud, 'update'> = new Crud();
  public student_grade: Pick<Crud, 'update'> = new Crud();
  public student_voucher: Pick<Crud, 'delete' | 'create'> = new Crud();
  public student_reschedule: Pick<Crud, 'update'> = new Crud();
  public student_label: Pick<Crud, 'update' | 'delete'> = new Crud();
  public student_notification: Pick<Crud, 'create'> = new Crud();
  public cashpay: Pick<Crud, 'use'> = new Crud();
  public student: Crud = new Crud();
  public payment: Crud = new Crud();
  public camp: Crud = new Crud();
  public camp_resume: Pick<Crud, 'read'> = new Crud();
  public course: Crud = new Crud();
  public periode: Crud = new Crud();
  public template: Crud = new Crud();
  public educations: Crud = new Crud();
  public acroom: Crud = new Crud();
  public quotas: Crud = new Crud();
  public branches: Crud = new Crud();
  public vouchers: Crud = new Crud();
  public user: Crud = new Crud();
  public pickup: Crud = new Crud();
  public pickup_task: Pick<Crud, 'read' | 'update'> = new Crud();
  public provinces: Crud = new Crud();
  public adminfee: Crud = new Crud();
  public grade: Crud = new Crud();
  public course_category: Crud = new Crud();
  public meet_hour: Crud = new Crud();
  public label: Crud = new Crud();
}

export class CampData {
  public id: number;
  public branch_id: number;
  public branch: BranchData;
  public name: string;
  public occupant_gender: string;
  public capacity: number;
  public empty_slot: number;
  public owner: string;
  public address: string;
  public contact_number: string;
  public ownership_status: string;
  public contract_begin?: string;
  public contract_end?: string;
  public contract_value?: number;
  public contract_lenght?: number;
  public reminder?: string;
  public price_one_week?: number;
  public price_two_week?: number;
  public price_three_week?: number;
  public price_one_month?: number;
  public price_ac_one_week?: number;
  public price_ac_two_week?: number;
  public price_ac_three_week?: number;
  public price_ac_one_month?: number;
  public quota?: number;
  public has_ac = '0';
  public active = '1';
  public updated_by: string;
  public deleted_at: string;
  public created_at: string;
  public updated_at: string;
  public pivot?: CampStudentPivotData;
  public checked_in_student?: StudentData[];
  public checked_in_full_service_student?: StudentData[];
  public occupancy_report?: CampOccupancyReportData;
  public weekly_occupancy?: WeeklyOccupancy[];
  public monthly_occupancy?: MonthlyOccupacy[];
}

export class ListCampResponse {
  public current_page: number;
  public data: CampData[] = [];
  public first_page_url: string;
  public from: number;
  public next_page_url: string;
  public per_page: number;
  public prev_page_url: string;
  public to: number;
}

export class CampAdditionalData {
  public empty_at?: number;
  public allocated?: number;
}
export class GetCampResponse {
  public camp: CampData;
  public data = new CampAdditionalData();
}

export class GetaCampParams {
  public periode?: PeriodeData;
  public course?: CourseData;
}

export class CampFilter {
  public page?: number;
  public name?: string;
  public branch_id?: string;
  public occupant_gender? = '';
  public owner?: string;
  public ownership_status? = '';
  public has_ac? = '';
  public active? = '';
  public hasEmpty?: number;
  public isFull?: number;
  public hasOccupant?: number;
  public occupantPeriode?: string;
  public occupantCourses?: string[];
  public per_page?: number;
  public has_laundry?: number;
  public has_full_service?: number;
}

export class LaundryVendorData {
  public id?: number;
  public branch_id?: number;
  public branch: BranchData;
  public camp?: CampData[];
  public name: string;
  public contact_person: string;
  public contact_number: string;
}

export class LaundryVendorFilter {
  public page?: number;
  public name?: string;
  public contact_person?: string;
  public contact_number?: string;
  public per_page?: number;
  public hasCustomer: number;
}

export class ListLaundryVendorResponse {
  public current_page: number;
  public data: LaundryVendorData[] = [];
  public first_page_url: string;
  public from: number;
  public next_page_url: string;
  public per_page: number;
  public prev_page_url: string;
  public to: number;
}

export class CampAutoMapData {
  public camp_id: number;
  public periode_date: number;
  public periode_month: number;
  public gender: string;
  public students: number[];
}

export class CampStudentPivotData {
  public camp_id: number;
  public student_id: number;
  public checkin_time: string;
  public checkout_time: string;
  public status: string;
}

export class StudentCount {
  public student_checkin: number;
  public student_count: number;
}

export class UnalocatedStudentCount {
  public male_count = 0;
  public female_count = 0;
}

export class OccupancyReportFilter {
  public name?: string;
  public gender = '';
  public listId?: number[];
  public per_page = 10;
  public page = 1;
  public sorting: string;
  public download? = false;
}

export class CampOccupancyReportData {
  public camp?: CampData;
  public camp_id: number;
  public capacity: number;
  public stay: number;
  public empty_slot: number;
  public id: number;
  public periode_list: string;
  public previous_1: number;
  public previous_2: number;
  public previous_3: number;
  public previous_4: number;
  public avg: number;
  public snapshot_date: string;
}

export class CampOccupancyReportReponse {
  public current_page: number;
  public prev_page_url: string;
  public next_page_url: string;
  public data: CampOccupancyReportData[];
  public previous_periode: string[];
}

export class PaymentResumeContent {
  public student: number;
  public cost: number;
}

export class CampPaymentResume {
  public oneWeek: PaymentResumeContent;
  public twoWeeks: PaymentResumeContent;
  public threeWeeks: PaymentResumeContent;
  public oneMonth: PaymentResumeContent;
  public totalCost: number;
}

export class CampPaymentReportData {
  public snapshotDate: string;
  public camp: CampData;
  public students: StudentData[];
  public resume: CampPaymentResume;
}
// export class CampPaymentReportData {
//   public snapshotDate: string;
//   public camp: CampData;
//   public students: StudentData[];
//   public resume: CampPaymentResume;
// }

export class LaundryPrintOutData {
  public snapshotDate: string;
  public data: LaundryVendorData;
  public dateList: number[];
}

export class CateringPrintOutData {
  public snapshotDate: string;
  public data: CampData;
  public dateList: number[];
}

export class CampActHistoryData {
  public camp_id: number;
  public time: string;
  public id: number;
  public status: string;
}

export class CampOccupancyFilter {
  public listId?: number[];
  public periode = '4P';
  public per_page?: number;
}

export class WeeklyOccupancy {
  public id: number;
  public camp_id: number;
  public occupancy: number;
  public start_of_week: string;
  public week: number;
  public year: number;
}

export class MonthlyOccupacy {
  public id: number;
  public camp_id: number;
  public occupancy: number;
  public month: number;
  public year: number;
  public created_at: string;
}

export class AcademicMainClassData {
  public id: number;
  public name: string;
  public description?: string;
  public active_students?: StudentData[];
  public teachers?: AcademicTeacherData[];
}

export class AcademicMainClassFilter {
  public page?: number;
  public name?: string;
  public sort?: string;
  public per_page?: number;
}

export class ListAcademicMainClassResponse {
  public current_page: number;
  public data: AcademicMainClassData[] = [];
  public first_page_url: string;
  public from: number;
  public next_page_url: string;
  public per_page: number;
  public prev_page_url: string;
  public to: number;
}

export class AcademicCampClassData {
  public id: number;
  public name: string;
  public description?: string;
  public teacher_id: number;
  public teacher?: AcademicTeacherData;
  public active_students?: StudentData[];
}

export class AcademicCampClassFilter {
  public page?: number;
  public name?: string;
  public withTeacher?: boolean;
  public sort?: string;
  public per_page?: number;
}

export class ListAcademicCampClassResponse {
  public current_page: number;
  public data: AcademicCampClassData[] = [];
  public first_page_url: string;
  public from: number;
  public next_page_url: string;
  public per_page: number;
  public prev_page_url: string;
  public to: number;
}

export class AcademicClassroomData {
  public id: number;
  public name: string;
  public description?: string;
}

export class AcademicClassroomFilter {
  public page?: number;
  public name?: string;
  public per_page?: number;
}

export class ListAcademicClassroomResponse {
  public current_page: number;
  public data: AcademicClassroomData[] = [];
  public first_page_url: string;
  public from: number;
  public next_page_url: string;
  public per_page: number;
  public prev_page_url: string;
  public to: number;
}

export class AcademicTeacherData {
  public id: number;
  public name: string;
  public description?: string;
}

export class AcademicTeacherFilter {
  public page?: number;
  public name?: string;
  public per_page?: number;
}

export class ListAcademicTeacherResponse {
  public current_page: number;
  public data: AcademicTeacherData[] = [];
  public first_page_url: string;
  public from: number;
  public next_page_url: string;
  public per_page: number;
  public prev_page_url: string;
  public to: number;
}

export class AcademicResult {
  public id?: number;
  public student_id: number;
  public month: number;
  public week: number;
  public vocabulary?: number;
  public speaking?: number;
  public integrated_speaking?: number;
  public listening_for_speaking?: number;
  public grammar_for_speaking?: number;
  public grammar?: number;
  public pronounciation?: number;
  public reading?: number;
  public writing?: number;
  public grammar_for_writting?: number;
  public listening?: number;
  public structure?: number;
}

export class StudentMonthlyResult {
  public student: StudentData;
  public subject: string;
  public month: number;
  public week1: number;
  public week2: number;
  public week3: number;
  public week4: number;
  public avg: number;
}

export class AResult {
  public subject = '';
  public value = 0;
}
export class NewResult {
  public month = 1;
  public week = 1;
  public result: AResult[] = [];
}

export class ChangeClassData {
  public students: StudentData[];
  public mainClass?: AcademicMainClassData;
  public campClass?: AcademicCampClassData;
}

export class GetClassFilter {
  public withTeacher? = false;
  public withStudent? = false;
}

export class CertificateData {
  id: number;
  student_id: number;
  type: string;
  cert_code: string;
  cert_number: string;
}

export class AcademicSum {
  public subject: string;
  public result: number;
}

export class BranchData {
  public id: number;
  public code: string;
  public name: string;
  public code_bank: string;
  public rekening_number: string;
  public description: string;
  public active: number;
  public province_id: number;
  public province_name: string;
  public data: [];
}
/// START
/// DATA TYPE FOR PROVINCE RELATION
/// PROVINCE TO BRANCH (ONE TO MANY)
/// PROVINCE TO JENJANG/EDUCATION (MANY TO MANY)
/// NOTE BY NURHAMSAH
export class ProvinceDataModel {
  public id: number;
  public code: string;
  public name: string;
  public active: number;
  public data: [];
}
export class ListProvinceFilter {
  public name?: string;
  public code: string;
  public active = '';
  public page = 1;
  public per_page = 10;
}

export class ListProvinceDataResponse {
  public current_page: number;
  public data: ProvinceDataModel[] = [];
  public first_page_url: string;
  public from: number;
  public next_page_url: string;
  public per_page: number;
  public prev_page_url: string;
  public to: number;
}
/// END

/// LABELS (MASTER DATA CRUD)
export class LabelDataModel {
  public id?: number;
  public name: string;
  public color: string;
  public status: number;
}
export class ListLabelFilter {
  public name?: string;
  public status = '';
  public page = 1;
  public per_page = 10;
}

export class ListLabelDataResponse {
  public current_page: number;
  public data: LabelDataModel[] = [];
  public first_page_url: string;
  public from: number;
  public next_page_url: string;
  public per_page: number;
  public prev_page_url: string;
  public to: number;
}
/// END LABELS

/// STUDENT NOTIFICATION (KIRIM PESAN)
export type NotificationMedia = 'WHATSAPP' | 'EMAIL' | 'SMS' | 'PDF';

export class NotificationTemplateItem {
  public id: number;
  public type: string;
  public template_name: string | null;
  public channel: string | null;
  public language: string | null;
  public subject: string | null;
}

export class NotificationWhatsappInfo {
  // channel yang sedang dipilih (null bila belum ada default dan belum dipilih)
  public channel: string | null;
  // channel default CS siswa dari lead-service (null bila tidak diketahui)
  public default_channel: string | null;
  public channels: string[] = [];
  public onesender_ready: boolean;
  public supports_free_text: boolean;
  public warning: string | null;
}

export class NotificationTemplatesResponse {
  public media: string;
  public templates: NotificationTemplateItem[] = [];
  public whatsapp: NotificationWhatsappInfo | null;
  public error: string | null;
}

export class NotificationPreview {
  public subject: string | null;
  public message: string;
  public is_params: boolean;
  public params: { key: string; value_text: string }[] | null;
}

export class SendNotificationPayload {
  public media: NotificationMedia;
  public mode: 'template' | 'free';
  public channel?: string;
  public template_id?: number;
  public subject?: string;
  public message?: string;
}

export class SendNotificationResponse {
  public ok: boolean;
  public channel: string | null;
  public message: string;
}
/// END STUDENT NOTIFICATION
export class ListBranchFilter {
  public name?: string;
  public periode?: any;
  public active = '';
  public page = 1;
  public per_page = 10;
}

export class ListBranchResponse {
  public current_page: number;
  public data: BranchData[] = [];
  public first_page_url: string;
  public from: number;
  public next_page_url: string;
  public per_page: number;
  public prev_page_url: string;
  public to: number;
}

export class VoucherData {
  public id: number;
  public cabang: string[];
  public paket_kursus: string[];
  public code: string;
  public percent = 0;
  public nominal = 0;
  public description?: string;
  public status: number;
}

export class ListVoucherFilter {
  public code?: string;
  public branch: string[];
  public paket_kursus: string[];
  public status? = '';
  public page? = 1;
  public per_page? = 10;
  public morePage: string;
}

export class ListVoucherResponse {
  public current_page: number;
  public branch: BranchData;
  public data: VoucherData[] = [];
  public first_page_url: string;
  public from: number;
  public next_page_url: string;
  public per_page: number;
  public prev_page_url: string;
  public to: number;
}

export class EducationData {
  public id?: number;
  public jenjang?: string;
  public code?: string;
  public status?: number;
  public cabang: string[];
  public province: string[];
  public is_renewal?: boolean;
}

export class EducationDataFilter {
  public per_page = 10;
  public page = 1;
  public jenjang: string;
  public code: string;
  public status: number;
  public branch: string[];
  public province: string[];
}

export class ListEducationResponse {
  public current_page: number;
  public data: EducationData[] = [];
  public first_page_url: string;
  public from: number;
  public next_page_url: string;
  public per_page: number;
  public prev_page_url: string;
  public to: number;
}

export class AcRoomData {
  public name: string;
  public id: number;
  public capacity: number;
  public duration: number;
  public gender: string;
  public quota = 0;
  public amount: number;
  public status: number;
  public branch: BranchData[] = [];
  public branch_id: number;
  public action?: string;
}

export class AcRoomResponse {
  public current_page: number;
  public result: AcRoomData[] = [];
  public first_page_url: string;
  public from: number;
  public next_page_url: string;
  public per_page: number;
  public prev_page_url: string;
  public morePage: string;
  public to: number;
}

export class AcRoomFilter {
  public name?: string;
  public branch?: string[];
  public gender?: string;
  public status?: string;
  public page = 1;
  public per_page = 10;
}

export class ExtendsProgramData {
  public id?: number;
  public regcode: string;
  public cs?: string;
  public cs_new?: string;
  public name: string;
  public phone: string;
  public email: string;
  public periode: string;
  public course_name: string;
  public full_payment: number;
  public periode_new?: string;
  public course_name_new?: string;
  public full_payment_new?: string;
  public session_id?: string;
  public branch: string;
  public branch_new?: string;
  public education: string;
  public education_new?: string;
  public camp?: string;
  public camp_new?: string;
  public url?: string;
  public price?: number;
  public cost_discount?: number;
  public price_new?: number;
  public meet_hour_id?: number | null;
  public grade_id?: number | null;
}

export class DataCs {
  public id?: number;
  public cs: string;
  public whatsapp: string;
  public counter: number;
  public kategori: string;
  public branch: string;
  public status: number;
  public token: string;
  public persen: number;
}

export class FilterDataCs {
  public id?: number;
  public cs?: string;
  public whatsapp?: string;
  public counter?: number;
  public kategori?: string;
  public branch?: string;
  public status?: number;
  public token?: string;
  public persen?: number;
}

export class DownloadAccessData {
  public id?: number;
  public code: string;
  public name: string;
  public desc: string;
}

// ===== Resume Registrasi (revamp) =====

export type ResumeBucketKey = 'dp' | 'cicilan' | 'lunas' | 'batal' | 'lainnya';

/**
 * Key yang valid untuk parameter filter status:
 * bucket asli + bucket gabungan khusus filter ('sudah_bayar' = dp + cicilan + lunas).
 */
export type ResumeStatusFilterKey = ResumeBucketKey | 'sudah_bayar';

export interface ResumeLegendItem {
  bucket: ResumeBucketKey;
  label: string;
  statuses: string[];
}

export interface ResumeCourseRow {
  course: string;
  course_name: string;
  male: number;
  female: number;
  total: number;
  buckets: Record<ResumeBucketKey, number>;
}

export interface ResumeGradeRow {
  grade_id: number | null;
  grade_name: string;
  male: number;
  female: number;
  total: number;
}

export interface ResumeJenjangRow {
  code: string | null;
  jenjang: string;
  male: number;
  female: number;
  total: number;
}

export interface RegistrationResumeResponse {
  meta: {
    periode: string;
    branch: string | null;
    bucket: ResumeStatusFilterKey | null;
    is_downloadable: boolean;
  };
  legend: ResumeLegendItem[];
  totals: {
    total: number;
    male: number;
    female: number;
    by_bucket: Record<ResumeBucketKey, number>;
  };
  per_course: ResumeCourseRow[];
  per_grade: ResumeGradeRow[];
  per_jenjang: ResumeJenjangRow[];
}

export interface ResumeDrilldownFilter {
  periode: string;
  branch?: string;
  bucket?: ResumeStatusFilterKey;
  course?: string;
  gender?: string;
  grade_id?: number | 'none';
  jenjang?: string;
  page?: number;
  per_page?: number;
}

export interface ResumeDrilldownRow {
  regcode: string;
  name: string;
  gender: string;
  status: string;
  bucket: ResumeBucketKey;
  course_name: string;
  branch: string;
  education: string | null;
  grade_name: string | null;
  created_at: string;
}

export interface ResumeDrilldownResponse {
  data: ResumeDrilldownRow[];
  meta: {
    page: number;
    per_page: number;
    total: number;
    last_page: number;
  };
}

// ===== Resume Siswa (revamp) =====

export type StudentStatusGroupKey = 'checkin' | 'graduated';

export interface StudentResumeStatusGroupLegend {
  key: StudentStatusGroupKey;
  label: string;
  statuses: string[];
}

export interface StudentResumeCourseRow {
  course: string;
  course_name: string;
  male: number;
  female: number;
  male_ac: number;
  female_ac: number;
  total: number;
  status_groups: Record<StudentStatusGroupKey, number>;
}

export interface StudentResumeResponse {
  meta: {
    periode: string;
    branch: string | null;
    is_rombongan: string | null;
    is_retention: string | null;
    is_downloadable: boolean;
    /** Punya hak download laporan siswa (unduh daftar siswa di balik resume). */
    can_download_students: boolean;
  };
  legend: {
    population: string[];
    status_groups: StudentResumeStatusGroupLegend[];
  };
  totals: {
    total: number;
    male: number;
    female: number;
    male_ac: number;
    female_ac: number;
    by_status_group: Record<StudentStatusGroupKey, number>;
  };
  per_course: StudentResumeCourseRow[];
  per_grade: ResumeGradeRow[];
  per_jenjang: ResumeJenjangRow[];
}

export interface StudentResumeDrilldownFilter {
  periode: string;
  branch?: string;
  is_rombongan?: string;
  is_retention?: string;
  status_group?: StudentStatusGroupKey;
  course?: string;
  gender?: string;
  /** '1' = hanya baris ber-AC (sel Putra/Putri AC). */
  ac?: '1';
  grade_id?: number | 'none';
  jenjang?: string;
  page?: number;
  per_page?: number;
}

export interface StudentResumeDrilldownRow {
  regcode: string;
  name: string;
  gender: string;
  status: string;
  course_name: string;
  branch: string;
  education: string | null;
  grade_name: string | null;
  ac_room: boolean;
  created_at: string;
}

export interface StudentResumeDrilldownResponse {
  data: StudentResumeDrilldownRow[];
  meta: {
    page: number;
    per_page: number;
    total: number;
    last_page: number;
  };
}

// ===== Cashpay (revamp) =====

/**
 * Channel key dari BE (CashpayChannel): 'cash' | 'transfer' | 'qris'
 * | 'edc_<BANK>' (dinamis per bank) | 'lainnya'.
 */
export type CashpayChannelKey = string;

export interface CashpayChannelInfo {
  key: CashpayChannelKey;
  label: string;
}

export interface CashpayCashierRow {
  cashier: string;
  cashier_name: string;
  course: Record<CashpayChannelKey, number>;
  pickup: Record<CashpayChannelKey, number>;
  total_course: number;
  total_pickup: number;
  total_cash: number;
  total: number;
  count: number;
}

export interface CashpayGrandRow {
  course: Record<CashpayChannelKey, number>;
  pickup: Record<CashpayChannelKey, number>;
  total_course: number;
  total_pickup: number;
  total_cash: number;
  total: number;
  count: number;
}

export interface CashpayResumeFilter {
  payment_date: string;
  date: number;
  month: number;
  year: number;
  branch?: string;
}

export interface CashpayResumeResponse {
  meta: {
    payment_date: string;
    periode: { date: number; month: number; year: number };
    branch: string | null;
    is_downloadable: boolean;
  };
  channels: CashpayChannelInfo[];
  cashiers: CashpayCashierRow[];
  grand: CashpayGrandRow;
}

export interface CashpayDrilldownFilter extends CashpayResumeFilter {
  cashier?: string;
  channel?: CashpayChannelKey;
  page?: number;
  per_page?: number;
}

export interface CashpayPaymentRow {
  payment_id: number;
  date: string;
  regcode: string;
  name: string;
  type: string;
  method: string | null;
  bank: string | null;
  channel: CashpayChannelKey;
  nominal: number;
  edc_cost: number;
  course_amount: number;
  pickup_amount: number;
  course_name: string;
  branch: string;
  cashier: string;
  created_at: string;
}

export interface CashpayPaymentsResponse {
  data: CashpayPaymentRow[];
  meta: {
    page: number;
    per_page: number;
    total: number;
    last_page: number;
  };
  totals: {
    nominal: number;
    course_amount: number;
    pickup_amount: number;
  };
}

// ===== Resume Camp =====

export interface CampResumeSummary {
  total_students: number;
  sudah_checkin: number;
  belum_checkin: number;
  checkedin_camp: number;
  unmapped: number;
  total_termapping: number;
}

export interface CampResumeRow {
  camp_id: number;
  camp_name: string;
  branch_id: number | null;
  branch_name?: string;
  branch_code?: string;
  belum_checkin: number;
  sudah_checkin: number;
  checkedin_camp: number;
  total: number;
}

export interface CampResumeTableTotals {
  belum_checkin: number;
  sudah_checkin: number;
  checkedin_camp: number;
  total: number;
}

export interface CampResumeResponse {
  meta: {
    periode: string;
    branch: string | null;
    can_download_students?: boolean;
  };
  summary: CampResumeSummary;
  camps: CampResumeRow[];
  table_totals: CampResumeTableTotals;
}

export interface CampResumeDrilldownFilter {
  periode: string;
  branch?: string;
  type?: 'total' | 'belum_checkin' | 'sudah_checkin' | 'checkedin_camp' | 'unmapped' | 'camp';
  camp_id?: number;
  status_masuk?: 'belum_checkin' | 'sudah_checkin' | 'checkedin_camp' | 'all';
  page?: number;
  per_page?: number;
}

export interface CampResumeDrilldownRow {
  id: number;
  regcode: string;
  name: string;
  gender: string;
  payment_status: string;
  is_admin_checkin: boolean;
  admin_checkin_label: string;
  camp_id: number | null;
  camp_name: string;
  camp_branch_name?: string;
  camp_pivot_status: string | null;
  camp_status_label: string;
  course_name: string;
  branch: string;
  created_at: string;
  periode_date: number;
  periode_month: number;
  periode_year: number;
  course_duration: number;
  ac_room: boolean;
  /** Belum punya camp dan belum check-in: boleh di-assign dari daftar. */
  can_assign: boolean;
}

export interface CampResumeDrilldownResponse {
  data: CampResumeDrilldownRow[];
  meta: {
    page: number;
    per_page: number;
    total: number;
    last_page: number;
  };
}

